// FTEDN Creator — Product Detail (ingredients, stats, timeline)
import type { ProductDetail as ProductDetailType } from '../../stores/product.store';

interface ProductDetailProps {
  product: ProductDetailType;
}

export function ProductDetail({ product }: ProductDetailProps) {
  return (
    <div className="product-detail">
      {/* Ingredient list */}
      {product.ingredientList.length > 0 && (
        <div className="detail-section">
          <h3>🧬 Key Ingredients</h3>
          <div className="ingredient-list">
            {product.ingredientList.map((ing, i) => (
              <span key={i} className="ingredient-chip">{ing}</span>
            ))}
          </div>
        </div>
      )}

      {/* Stats */}
      <div className="detail-section">
        <h3>📊 Community Impact</h3>
        <div className="detail-stats">
          <div className="detail-stat">
            <span className="detail-stat-value">{product.stats.testerCount}</span>
            <span className="detail-stat-label">Testers</span>
          </div>
          <div className="detail-stat">
            <span className="detail-stat-value">{product.stats.reviewCount}</span>
            <span className="detail-stat-label">Reviews</span>
          </div>
          <div className="detail-stat">
            <span className="detail-stat-value">{product.stats.feedbackCount}</span>
            <span className="detail-stat-label">Feedback</span>
          </div>
          <div className="detail-stat">
            <span className="detail-stat-value">{product.stats.voteCount}</span>
            <span className="detail-stat-label">Votes</span>
          </div>
        </div>
      </div>

      {/* Timeline */}
      {product.publicTimeline.length > 0 && (
        <div className="detail-section">
          <h3>📅 Product Timeline</h3>
          <div className="detail-timeline">
            {product.publicTimeline.map(entry => (
              <div key={entry.id} className="timeline-item">
                <div className="timeline-dot" />
                <div className="timeline-content">
                  <strong>{entry.title}</strong>
                  {entry.description && <p>{entry.description}</p>}
                  <span className="timeline-date">{entry.addedAt}</span>
                </div>
              </div>
            ))}
          </div>
        </div>
      )}
    </div>
  );
}
